import type { CredentialResponse } from "@react-oauth/google";
import { Cookies } from "react-cookie";
import { decodeToken } from "react-jwt";

import { StaticValue } from "../../seed/constants";

const staticValues = new StaticValue().getDefaultValues();

export interface GoogleProfile {
	email: string;
	firstName: string;
	lastName: string;
	picture: string;
}

type GoogleIdTokenPayload = Omit<GoogleProfile, "firstName" | "lastName"> & {
	given_name: string;
	family_name: string;
};

export interface GoogleSession {
	credential: string;
	expiresAt: Date;
	profile: GoogleProfile;
}

const CREDENTIAL_LIFETIME_DAYS = 30;

export function establishGoogleSession(googleUser: CredentialResponse): GoogleSession | null {
	if (!googleUser.credential) return null;

	const credential = `GO::${googleUser.credential}`;
	new Cookies().remove(staticValues.localStorageResumeId, { path: "/" });
	localStorage.removeItem("resumeList");

	const payload = decodeToken<GoogleIdTokenPayload>(googleUser.credential);
	const expiresAt = new Date();
	expiresAt.setDate(expiresAt.getDate() + CREDENTIAL_LIFETIME_DAYS);

	return {
		credential,
		expiresAt,
		profile: {
			email: payload.email,
			firstName: payload.given_name,
			lastName: payload.family_name,
			picture: payload.picture,
		},
	};
}
